import { Logger, Models, Types } from '@sendum/core'
import { Reducer } from 'redux'

import { TActionProps, TimelineActionTypes } from './TimelineActions'
import { DispatchAction } from './TimelineStore'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const logger = new Logger('TimelineReducer')

export interface ITimelineState {
    segments: Models.Segment[]
    isLoading: boolean
    id?: string
    config?: Types.TTimeLineAttribute
    error: Error | null
}

const initialState: ITimelineState = {
    segments: [],
    isLoading: false,
    error: null
}

const updateStateByMqtt = (state: ITimelineState, payload: TActionProps): ITimelineState => {
    logger.debug('updateStateByMqtt', payload)
    const msg = (JSON.parse(payload.message as string) as unknown) as { segments: Models.Segment[]; Device: string }

    if (!msg.Device && !msg.segments) {
        logger.debug('\n\n discard Mqtt message processing')

        return state
    }

    const newState = {
        ...state
    }

    if (msg.segments && msg.segments.length) {
        const { segments } = msg
        segments.forEach((segment: any) => {
            const segmentIndex: number | undefined = newState.segments.findIndex(s => s?.id === segment.segmentId)
            if (segmentIndex !== undefined && newState.segments[segmentIndex]) {
                const _segment = newState.segments[segmentIndex]
                _segment.status = segment.status
                const { milestones } = segment
                if (milestones && milestones.length) {
                    milestones.forEach((milestone: any) => {
                        const milestoneIndex: number | undefined = newState.segments[segmentIndex].milestones.findIndex(
                            m => m?.id === milestone.milestoneId
                        )
                        if (
                            milestoneIndex !== undefined &&
                            newState.segments[segmentIndex].milestones[milestoneIndex]
                        ) {
                            const _milestone = newState.segments[segmentIndex].milestones[milestoneIndex]
                            _milestone.actualEpochTime = milestone.actualEpochTime
                        }
                    })
                }
            }
        })
    }

    return newState
}

export const TimelineReducer: Reducer<ITimelineState, DispatchAction<TimelineActionTypes, TActionProps>> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case TimelineActionTypes.SET_SEGMENTS: {
            if (state.id !== action.payload.id) {
                return state
            }

            return { ...state, ...{ segments: action.payload.segments || [] } }
        }
        case TimelineActionTypes.SET_LOADING: {
            if (action.payload.id && state.id !== action.payload.id && !action.payload.isLoading) {
                return state
            }

            return { ...state, ...{ isLoading: action.payload.isLoading || false } }
        }
        case TimelineActionTypes.SET_ID: {
            return { ...state, ...{ id: action.payload.id } }
        }
        case TimelineActionTypes.SET_CONFIG: {
            return { ...state, ...{ config: action.payload.config } }
        }
        case TimelineActionTypes.SET_ERROR: {
            return { ...state, ...{ error: action.payload.error || null } }
        }
        case TimelineActionTypes.UPDATE_STATE_BY_MQTT: {
            return updateStateByMqtt(state, action.payload)
        }
        default:
            return state
    }
}
